import React from 'react';
import { startCase } from 'lodash';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons/faEye';
import { faEyeSlash } from '@fortawesome/free-solid-svg-icons/faEyeSlash';

import ListResource from './ListResource.jsx';
import ListCtrlActivates from './ListCtrlActivates.jsx';

const api = '/api/site/paymentRecords';

const ListPaymentRecords = () => {
  const filter = {};

  return (
    <ListResource
      {...{
        searchable: true,
        api,
        sort: { createdAt: -1 },
        filter,
        actions: {
          create: false,
          remove: false,
          fileImport: false,
          // fileExport: true,
        },
        cols: [
          { key: 'owner', label: 'Owner', sortable: true },
          { key: 'targetModel', label: 'Model', sortable: true },
          { key: 'action', sortable: true },
          { key: 'status', sortable: true },
          { key: 'dge', sortable: true},
          { key: 'gxe', sortable: true },
          { key: 'createdAt', sortable: true },
        ],
      }}></ListResource>
  );
};

export default ListPaymentRecords;
